import { makeStyles } from 'tss-react/mui';

export const useShowBannerStyles = makeStyles()(() => ({
  selectableItem: { position: 'absolute', bottom: '1.25rem', left: '1.5rem' },
  checkbox: {
    marginRight: '-1.5rem',
  },
}));
